import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {VariablesService} from "../variables.service";
import {ResponseFilterService} from "../response-filter.service";

@Injectable()
export class UserService {

    constructor(
        private http: HttpClient,
        private vars: VariablesService,
        private filter: ResponseFilterService
        ) {
    }

    public auth($user, $pass) {
        return this.filter.doFilter(
            this.http.post(this.vars.api(`front/user/login`),{login: $user, password: $pass},this.vars.httpConfig)
        )
    }

    public loadSession() {
    }

    public getProfile() {
    }

    public saveProfile() {
    }

}



// WEBPACK FOOTER //
// ./src/app/services/user/user.service.ts